import UISelect from 'UIComponents/input/UISelect';
import { CTA } from 'customer-data-filters-ui/filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { useCTAFilter } from '../../hooks/useCTAFilter';
import { useEditorActions } from '../../hooks/useEditorActions';
import { useFieldConditionChange } from '../../hooks/useFieldConditionChange';
import { useOperatorOptions } from '../../hooks/useOperatorOptions';
import ConditionError from '../common/ConditionError';
import EditorConditionValueInput from './EditorConditionValueInput';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'UICo... Remove this comment to see the full error message
import UITypeaheadResultsItem from 'UIComponents/typeahead/results/UITypeaheadResultsItem';
import EditorConditionAsset from './EditorConditionAsset';
import { useContext } from 'react';
import SegmentationFiltersInstanceContext from '../../state/SegmentationFiltersInstanceContext';
import EditorConditionRefinementsContainer from './EditorConditionRefinementsContainer';
import { useElementSize, MEDIA_SIZES } from '../../hooks/useElementSize';
import EditorCTARelatedConditionsGroup from './EditorCTARelatedConditionsGroup';
import ConditionBox from '../common/ConditionBox';
import { INPUT_WIDTHS_FOR_THREE_INPUTS_WITH_BULLET_POINT } from '../../constants/inlineLayout';
import InlineContainerWithEditorConditionActions from '../common/InlineContainerWithEditorConditionActions';
import FilterInfoWarnings from '../common/FilterInfoWarnings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EditorCTARelatedConditionsGroupResponsive = props => {
  var _condition$field;
  const {
    condition,
    conditionPath,
    dataSeleniumInfo
  } = props;
  const {
    width
  } = useElementSize();
  const {
    onConditionDelete
  } = useEditorActions();
  const {
    onFieldConditionFieldChange,
    onFieldConditionValueChange,
    onFieldConditionOperatorChange
  } = useFieldConditionChange(CTA, conditionPath, condition);
  const {
    statusCondition,
    subjectVersionCondition,
    refinementConditionsEmptyValue,
    onSubjectVersionValueChange
  } = useCTAFilter(condition, onFieldConditionValueChange);
  const {
    getTrackerInstance,
    props: {
      baseFilterFamily
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    options: operatorOptions,
    getOperatorByName
  } = useOperatorOptions(CTA, statusCondition);
  if (width.size === MEDIA_SIZES.sm) {
    return /*#__PURE__*/_jsx(EditorCTARelatedConditionsGroup, Object.assign({}, props));
  }

  //@ts-expect-error `userHasNoAccess` does not exist on `DSFieldRecordInstance`
  const userHasNoAccess = (_condition$field = condition.field) === null || _condition$field === void 0 ? void 0 : _condition$field.userHasNoAccess;
  const onSelectedOptionChange = evt => {
    var _getTrackerInstance, _condition$field2, _condition$field3;
    const operatorName = evt.target.value.value;
    onFieldConditionOperatorChange(getOperatorByName(operatorName));
    (_getTrackerInstance = getTrackerInstance()) === null || _getTrackerInstance === void 0 || _getTrackerInstance.track('changedFilterOperator', {
      operator: operatorName,
      primaryObjectTypeId: baseFilterFamily,
      property: (_condition$field2 = condition.field) === null || _condition$field2 === void 0 ? void 0 : _condition$field2.name,
      type: (_condition$field3 = condition.field) === null || _condition$field3 === void 0 ? void 0 : _condition$field3.type,
      version: '2'
    });
  };
  return /*#__PURE__*/_jsxs(ConditionBox, {
    children: [/*#__PURE__*/_jsxs(InlineContainerWithEditorConditionActions, {
      conditionPath: conditionPath,
      condition: condition,
      onConditionDelete: () => onConditionDelete(conditionPath),
      hideChangeFieldButton: true,
      isFilterBranch: true,
      filterFamily: CTA,
      children: [/*#__PURE__*/_jsx("div", {
        style: {
          width: INPUT_WIDTHS_FOR_THREE_INPUTS_WITH_BULLET_POINT[width.size]
        },
        children: /*#__PURE__*/_jsx(EditorConditionAsset, {
          condition: condition,
          filterFamily: CTA,
          onAssetChange: onFieldConditionFieldChange
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          width: INPUT_WIDTHS_FOR_THREE_INPUTS_WITH_BULLET_POINT[width.size]
        },
        children: /*#__PURE__*/_jsx(UISelect, {
          "data-selenium-info": dataSeleniumInfo,
          "data-selenium-test": "fr-filter-operator-select",
          "data-test-id": "fr-filter-operator-select",
          disabled: userHasNoAccess,
          onSelectedOptionChange: onSelectedOptionChange,
          optionRenderer: option => /*#__PURE__*/_jsx(UITypeaheadResultsItem, {
            message: true,
            option: option
          }),
          options: operatorOptions,
          value: condition.constructor.toString()
        })
      }), /*#__PURE__*/_jsx("div", {
        style: {
          width: INPUT_WIDTHS_FOR_THREE_INPUTS_WITH_BULLET_POINT[width.size]
        },
        children: /*#__PURE__*/_jsx(EditorConditionValueInput, {
          condition: subjectVersionCondition,
          disabled: userHasNoAccess,
          filterFamily: CTA,
          onChange: onSubjectVersionValueChange,
          size: "md"
        })
      })]
    }), /*#__PURE__*/_jsx(ConditionError, {
      condition: condition
    }), /*#__PURE__*/_jsx(FilterInfoWarnings, {
      condition: condition
    }), !userHasNoAccess && /*#__PURE__*/_jsx(EditorConditionRefinementsContainer, {
      condition: condition,
      conditionPath: conditionPath,
      filterFamily: CTA,
      onConditionChange: onFieldConditionValueChange,
      emptyRefinementConditions: refinementConditionsEmptyValue,
      hasInlineLayout: true
    })]
  });
};
export default EditorCTARelatedConditionsGroupResponsive;